import '../../styles/index.css'
import './Location.css';

function Location({local, subLocal}) {

    return (

        <div className='location'>
            <p className='b3'>Você está em: <span className='negrito'>{

                subLocal ? `${local} | "${subLocal}"` : `${local}`

            }</span></p>
        </div>

    );
}

export default Location;
